export const SET_SERVICE = 'SET_SERVICE'
export const RESET_SERVICE = 'RESET_SERVICE'